import React from "react";
import Product from "../Product/Product";

const NewArrivals = ({ products, onAdd }) => {
  return (
    <section className="section new__arrival" id="new__arrival">
      <div className="arrivals container">
        <div className="title">
          <h1 className="primary__title">New Arrival</h1>
        </div>

        <div className="arrival__center">
          {products.map((product) => (
            <Product product={product} key={product.id} onAdd={onAdd} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewArrivals;
